import React from "react";
import { Meta } from "../components/SEO";
import { generalFaqs } from "../data/faqs";
import { services } from "../data/services";
import { FaqAccordion } from "../components/FaqAccordion";
import { CtaStrip } from "../components/Sections";

export default function FaqPage() {
  const grouped = [
    { title: "Algemene vragen", items: generalFaqs },
    { title: "Badkamer renovatie", items: services.find((s) => s.slug === "badkamer-renovatie")?.faqs || [] },
    { title: "Keuken renovatie", items: services.find((s) => s.slug === "keuken-renovatie")?.faqs || [] },
    { title: "Aanbouw & uitbouw", items: services.find((s) => s.slug === "aanbouw")?.faqs || [] },
  ];

  return (
    <>
      <Meta
        title="Veelgestelde vragen — Renovatie & verbouwing | Koning"
        description="Antwoorden op veelgestelde vragen over verbouwen: vergunningen, doorlooptijd, garantie en offertes. Uw vraag niet beantwoord? Reactie binnen één werkdag."
      />

      <section className="pt-24 pb-12 md:pt-32 md:pb-16 border-b border-koning-border" data-testid="faq-hero">
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20">
          <div className="eyebrow mb-5">Veelgestelde vragen</div>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-white tracking-tight max-w-4xl">
            Alles wat u <span className="italic text-koning-gold">wilt weten</span>.
          </h1>
        </div>
      </section>

      <section className="py-20 md:py-28" data-testid="faq-content">
        <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-20 space-y-16">
          {grouped.map((g) => (
            <div key={g.title} data-testid={`faq-group-${g.title}`}>
              <h2 className="font-display text-2xl md:text-3xl text-koning-gold tracking-tight mb-6">{g.title}</h2>
              <FaqAccordion items={g.items} withSchema={g.title === "Algemene vragen"} />
            </div>
          ))}
        </div>
      </section>

      <CtaStrip title="Vraag niet beantwoord?" subtitle="Stel uw vraag via het contactformulier of bel direct. We helpen u graag." />
    </>
  );
}
